import { Route } from "react-router-dom";
import { _adr } from "../address";
import { Roles } from "../tools/services";
import { ProtectedRoute } from "../tools/protectedRoute";
import Search360 from "../components/360/search/search";
import ResultSearch360 from "../components/360/list/List360";

export const services360Routes = [
	<Route
		key="s360-search"
		path={_adr.Root + _adr.Services360.Index}
		element={<ProtectedRoute role={Roles.Delear_360_Customerservice} element={Search360} />}
	/>,
	<Route
		key="s360-list"
		path={_adr.Root + _adr.Services360.Index + _adr.Services360.List}
		element={<ProtectedRoute role={Roles.Delear_360_Customerservice} element={ResultSearch360} />}
	/>,
];
